var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import NavMenuTree from './NavMenuTree';
import NavMenuButton from './NavMenuButton';

var NavMenuTreeitem = function (_Component) {
    _inherits(NavMenuTreeitem, _Component);

    function NavMenuTreeitem() {
        var _temp, _this, _ret;

        _classCallCheck(this, NavMenuTreeitem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            expanded: false
        }, _this.onToggle = function () {
            _this.setState(function (prevState) {
                return {
                    expanded: !prevState.expanded
                };
            });
        }, _this.getItem = function () {
            var _this$props = _this.props,
                location = _this$props.location,
                menuByUrl = _this$props.menuByUrl;
            var item = _this.props.item;
            var _item = item,
                url = _item.url,
                hash = _item.hash;

            // merge

            if (url && menuByUrl[url]) {
                item = _extends({}, item, menuByUrl[url]);
            }

            // selected

            var selected = false;

            if (item.selected) {
                selected = item.selected;
            } else if (_this.props.url && _this.props.url === url) {
                selected = true;
            } else if (location && location.pathname === url) {
                selected = true;
            } else if (location && location.hash === hash) {
                selected = true;
            }

            // expanded

            var expanded = false;

            if (item.expanded) {
                expanded = item.expanded;
            } else if (_this.state.expanded) {
                expanded = _this.state.expanded;
            } else if (_this.props.url && _this.props.url.includes(url)) {
                expanded = true;
            } else if (location && location.pathname.includes(url)) {
                expanded = true;
            }

            return _extends({}, item, {
                selected: selected,
                expanded: expanded
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    NavMenuTreeitem.prototype.render = function render() {
        var item = this.getItem();

        var children = item.children,
            expanded = item.expanded,
            selected = item.selected,
            count = item.count;


        if (children) {
            return React.createElement(
                'li',
                { className: 'nav-menu__treeitem', role: 'treeitem', 'aria-expanded': expanded, 'data-count': count },
                React.createElement('i', { className: 'nav-menu__toggle', onClick: this.onToggle, 'aria-expanded': expanded }),
                React.createElement(NavMenuButton, _extends({}, this.props, { item: item, selected: selected })),
                React.createElement(NavMenuTree, _extends({}, this.props, { menu: children }))
            );
        }

        return React.createElement(
            'li',
            { className: 'nav-menu__treeitem', role: 'treeitem', 'data-count': count },
            React.createElement(NavMenuButton, _extends({}, this.props, { item: item, selected: selected }))
        );
    };

    return NavMenuTreeitem;
}(Component);

export default NavMenuTreeitem;